import { useNavigate } from 'react-router-dom'
import { useCallback, useRef, useEffect } from 'react'

export const useTaskDetailHandlers = (
  id: string,
  taskId: string,
  setExecuteTimeId: (id: string) => void,
  getEchartsData: (resultId?: string) => void,
  refreshRequest: (resultId?: string) => void,
  generateReport: (params: any) => Promise<any>,
  deleteTask: (params: any) => Promise<any>,
  setFailLogInfo: (info: any) => void,
  updateResourceInterceptStatus: (params: any) => Promise<any>,
  setRandom: (value: number) => void,
  setSelectedRowKeys: (keys: string[]) => void,
  getUseCaseList: (params: any) => Promise<any>,
  setUseCaseList: (list: any[]) => void,
  setUseCaseTotal: (total: number) => void,
  setFixPayloadCount: (count: number) => void,
  getResultPluginDetail: (params: any) => Promise<any>,
  setPluginDetail: (detail: any) => void,
  setDetailDrawerVisible: (visible: boolean) => void,
  setCardActive: (id: string) => void,
  setFixedModalVisible: (visible: boolean) => void,
  getTaskInfo: (params: any) => Promise<any>,
) => {
  const navigate = useNavigate()

  const handleToggleTime = (timeId: string) => {
    setExecuteTimeId(timeId)
    getEchartsData(timeId)
    refreshRequest(timeId)
  }

  const handleBack = () => {
    navigate('/validation/cloud/containersecurity?tab=task')
  }

  const createReport = (values: any, name: string) => {
    generateReport({
      task_list: [{ task_name: name, campaign_id: id }],
      ...values,
    })
      .then(() => {
        window.open('/report/task/task-report?tab=11', '_self')
      })
      .catch(() => {})
  }

  const handleDelete = async () => {
    try {
      if (id) {
        await deleteTask({ result_id_list: [id] })
        navigate('/validation/cloud/containersecurity?tab=task')
      }
    } catch (error) {
      // Handle error
    }
  }

  const handleExpand = useCallback(() => {
    console.log('handleExpand')
  }, [id, setFailLogInfo])

  const handleFixed = (values: any, selectedRowKeys: string[], form: any) => {
    const { interceptStatus } = values

    return updateResourceInterceptStatus({
      id: id,
      list: {
        taskResultResourceList: selectedRowKeys.map(key => ({
          pluginId: key,
          interceptStatus:
            interceptStatus === 'intercept_no_verification'
              ? 'InterceptStatusCancel'
              : interceptStatus,
        })),
      },
    })
      .then(() => {
        setRandom(new Date().getTime())
        form.resetFields()
        setSelectedRowKeys([])
        const params = { limit: 20, page: 1 }
        return getUseCaseList({ result_id: id, task_id: taskId, ...params })
          .then(res => {
            setUseCaseList(res.data.items)
            setUseCaseTotal(res.data.total)
            setFixPayloadCount(res.data.manualCorrectCount)
            getTaskInfo({ resultId: id, taskId: taskId }).catch(() => {})
          })
          .catch(() => {})
      })
      .finally(() => {
        setFixedModalVisible(false)
      })
      .catch(() => {})
  }

  const handleChecked = (
    e: any,
    cardId: string,
    selectedRowKeys: string[],
    setSelectedRowKeysFn: (keys: string[]) => void,
  ) => {
    let newSelectedRowKeys = [...selectedRowKeys]
    const selectedkey = e[0]
    if (!selectedkey) {
      newSelectedRowKeys = newSelectedRowKeys.filter(key => key !== cardId)
    } else {
      if (newSelectedRowKeys.includes(selectedkey)) {
        newSelectedRowKeys = newSelectedRowKeys.filter(key => key !== selectedkey)
      } else {
        newSelectedRowKeys.push(selectedkey)
      }
    }
    setSelectedRowKeysFn(newSelectedRowKeys)
  }

  const handleActive = (e: any, key: string) => {
    if (e.target.className === 'ant-checkbox-input') return
    getDrawerData(key)
    setCardActive(key)
  }

  const getDrawerData = (taskPayloadId: string) => {
    setDetailDrawerVisible(true)
    getResultPluginDetail({
      result_id: id || '',
      id: taskPayloadId,
    })
      .then(res => {
        setPluginDetail(res?.data)
      })
      .catch(() => {})
  }

  return {
    handleToggleTime,
    handleBack,
    createReport,
    handleDelete,
    handleExpand,
    handleFixed,
    handleChecked,
    handleActive,
    getDrawerData,
  }
}
